var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 2000 2000",
    width: "2000pt",
    height: "2000pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 1544.601 1169 L 1894 1774 L 1559.039 1774 L 1447 1580 L 1209.64 1169 L 1544.601 1169 Z  M 1167.3 515.688 L 1000 226 L 553 1000 L 106 1774 L 440.961 1774 L 553 1580 L 790.36 1169 L 790 1169 L 1167.3 515.688 Z ",
    fillRule: "evenodd",
    fill: "rgb(255,255,255)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 1169,
    width: 528,
    height: 291.059,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a53e0ff1e2cbe4329cdff43cf0c3aa1.svg";
export { ForwardRef as ReactComponent };